module.exports = __webpack_public_path__ + "img/info-icon.9697fa9c.svg";